package org.bsvac.bsvac_kmp.ui

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.unit.dp
import org.bsvac.bsvac_kmp.data.BsvacTextStyle

@Composable
fun ContentSection(title: String, modifier: Modifier = Modifier, bsvacTextStyle: BsvacTextStyle) {
    Box(modifier = modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
        Text(title, fontSize = bsvacTextStyle.fontSize, autoSize = bsvacTextStyle.stepBasedAutoSize())
    }

}

fun Modifier.contentSectionBorder() = border(BorderStroke(2.dp, color = Color.Gray))